export default defineNuxtRouteMiddleware(() => {
  const { isAuthenticated } = useAuth();

  // if (!isAuthenticated.value) {
  //   return navigateTo("/sign-in");
  // }
  return navigateTo("/event/T7dRz3cyRcnBgGLiQTjh");
});
